import "core-js/modules/es.function.name.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import IconWarning from '../common/icons/Alert.vue';
import IconSuccess from './icons/IconSuccess.vue';
import IconError from './icons/IconError.vue';
import IconCancel from './icons/IconCancel.vue';
import { useAlertStore } from '~/store/alert';
export default /*#__PURE__*/_defineComponent({
  __name: 'BAlert',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var alertStore = useAlertStore();
    var timeout = ref(5000);
    var type = ref('success');
    var show = ref(false);
    var title = ref('');
    var message = ref('');
    var header = computed(function () {
      if (title.value) {
        return title.value;
      } else {
        switch (type.value) {
          case 'error':
            return t('main.alert');
          case 'warning':
            return t('main.warning');
          case 'success':
          default:
            return t('main.success');
        }
      }
    });
    function showNotification() {
      setTimeout(function () {
        show.value = false;
      }, timeout.value);
    }
    watch(show, function (newValue) {
      if (newValue) {
        showNotification();
      }
    });
    var unsubscribe = alertStore.$onAction(function (_ref) {
      var name = _ref.name,
        after = _ref.after;
      if (name === 'showMessage') {
        after(function () {
          var _alertStore$title;
          timeout.value = alertStore.timeout;
          title.value = (_alertStore$title = alertStore.title) !== null && _alertStore$title !== void 0 ? _alertStore$title : '';
          message.value = alertStore.content;
          type.value = alertStore.type;
          show.value = true;
        });
      }
    });
    onUnmounted(function () {
      unsubscribe();
    });
    return {
      __sfc: true,
      t: t,
      alertStore: alertStore,
      timeout: timeout,
      type: type,
      show: show,
      title: title,
      message: message,
      header: header,
      showNotification: showNotification,
      unsubscribe: unsubscribe,
      IconWarning: IconWarning,
      IconSuccess: IconSuccess,
      IconError: IconError,
      IconCancel: IconCancel
    };
  }
});